import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom'

import { useSelector, useDispatch } from 'react-redux'

import mapboxgl, { clearPrewarmedResources } from 'mapbox-gl';
import moment from 'moment';

const segmentMaxLengthMeter = SEGMENT_MAX_LENGTH_METER // 100 ;
const lineTimeoutMinutes = 600 ;
var lineWidth = TRAJECTORY_LINE_WIDTH ;
if (!lineWidth) lineWidth = 6

const EMPTY_FEATURES_DATA = {
  "type": "FeatureCollection",
  "features": [] 
}
const TEST_FEATURES_DATA = {
  "type": "FeatureCollection",
  "features": [{
    "type": "Feature",
    "properties": {"name": "Null Island"},
    "geometry": {
      "type": "LineString",
      "coordinates":  [[ 0, 0], [20, 20 ]]
    }
  }]
}

export default function ViewportItemTrajectory(props) {

  // if (props.viewportItemId == 1490) console.log("DEBUG: ViewportItemTrajectory 1490 render.")
  const map = useSelector((state) => state.ui.map)
  //const lastStateVisible = useSelector((state) => state.ui.itemLastStateVisible[props.viewportItemId]) ;
  const trajectoryVisible = useSelector((state) => state.ui.itemTrajectoryVisible[props.viewportItemId]) ;
  const locations =  useSelector((state) => state.viewport.itemMoLocations[props.viewportItemId])
  const stats = useSelector((state) => state.viewport.itemMoStats[props.viewportItemId])
  const layerId = props.layerId 

  // var segmentLineStrings = [] ;

  // popup html element of the component: 
  const popupRef = useRef(null)


  const getColoredLineStyle = (weight) => {
    if (weight <0) weight = 0;
    if (weight >1) weight = 1;

    var r = 255 * (1-weight) ;
    var g = 255 * weight ;
    var b = 0 ;
    return 'rgba(' + r + ', ' + g + ', ' + b + ', 1)'
  }
  
  const createSegmentFeature = (id, points, lineWidth, segmentLength, segmentNr, timeFrom, timeTo) => {

    // time: msec, length: meter
    var pace = ( timeTo - timeFrom ) / (segmentLength * 60.0 ) ;
    var kmh = 1 / pace * 60.0 ;
    // TODO color:
    var c = '#24248A' ;// 
    if (typeof TRAJECTORY_COLOR !== "undefined") c = TRAJECTORY_COLOR
    else c = getColoredLineStyle(kmh / 15.0) ; 
    
    var feature = {
      'type': 'Feature',
      'id': id,
      'properties': {
        'color': c,
        'line-width': lineWidth,
        'pace': pace,
        'timeFrom': timeFrom,
        'timeTo': timeTo,
        'segmentLength': segmentLength,
        'minzoom': 0, 
        'maxzoom': 24
      },
      'geometry': {
        'coordinates': points,
        'type': 'LineString'
      }
    }
    return feature ;
  }

  const clickHandler = (e) => {
    if  (POPUPS_DISABLED) return
    // console.log("pace:",  e.features[0].properties)
    // segment description
    var pace = e.features[0].properties.pace
    var desc = '<table class="mini">' +
      '<tr><td colspan="2"><strong>' +
      //'Túra-' + this.props.shortName + ' teljesítés kiválasztott szakasza</strong></td></tr>' +      
      props.displayName + '</strong></td></tr>' +
      '<tr><td>szakasz:</td><td>' +
      Math.round(100*e.features[0].properties.segmentLength)/100.0 + ' méter</td></tr>' +
      '<tr><td colspan="2">' +
      moment(parseInt(e.features[0].properties.timeFrom)).format('MM.DD HH:mm:ss') + ' - ' +
      moment(parseInt(e.features[0].properties.timeTo  )).format('MM.DD HH:mm:ss') + '</td></tr>' +
      '<tr><td>tempó: </td><td>'+
      (pace === Infinity ? "-" :
        Math.floor(pace) + ":" +
        String(Math.round((pace-Math.floor(pace))*60)).padStart(2, 0)
      ) +
      // Math.round(10.0 * e.features[0].properties.pace)/10.0 +
      ' min/km</td><td>' +
      //        moment(parseInt(s.timeGenerated)).format('YYYY-MM-DD HH:mm') + '</td></tr>' +
      //        '<tr><td></td><td>' +
      //        moment().diff( moment(parseInt(s.timeGenerated)), 'minutes')+ ' perce </td></tr>' +
      //        '<tr><td>sebesség: </td><td>' + s.speed + ' km/h </td></tr>' +
      //        '<tr><td>magasság: </td><td>' +  s.altitude + ' m </td></tr>' +
      //        '<tr><td>aksi: </td><td>' +
      //          Math.round(s.batteryVoltage*100)/100 + ' V</td></tr>' +
      '</table>' ;

      // moment(time-segmentTime).format('HH:mm:ss') +
      // ' - '+ moment(time).format('HH:mm:ss') + ": " +
      // Math.round(segmentDist*df*100)/100 + "m" +
      // '<br/>' +Math.round(ss * 100) / 100 + ' km/h (' +
      // Math.round(60/ss * 100) / 100 + ' min/km) , ' +
      // segmentAlt*10 + " m" +
      // '<br/><strong>full:</strong><br/>' + Math.round(fullDist*df/10)/100 + " km,   " +
      // (parseInt(moment(parseInt(time - beginTime)).format('DD'))-1) + " day " +
      // moment(parseInt(time - beginTime)-60*60*1000).format('HH:mm:ss') + ",   <br/>" +
      // Math.round( fs*100 )/100 + ' km/h (' +
      // Math.round(60/fs * 100) / 100 + ' min/km), <br/>' +
      // 'alt. diff.: ' + Math.round(fullAlt*10) + ' m';

    // display popup
    if (popupRef.current == null && ! POPUPS_DISABLED ) {
      popupRef.current = document.createElement('div');
    }
  
    if (popupRef.current && ! POPUPS_DISABLED) popupRef.current.remove()
    popupRef.current = new mapboxgl.Popup({
            closeButton: true,
            closeOnClick: true,
            anchor: 'bottom'
            // offset: [linearOffset, -linearOffset]
        }).setLngLat(e.features[0].geometry.coordinates[[0]])
        .setHTML(desc)
        .addTo(map);
  }
  // cursor shaope changing event handlers: 
  const pointerCursor = () => {
    map.getCanvas().style.cursor = 'pointer';
  }
  const normalCursor = () => {
    map.getCanvas().style.cursor = '';
  }      

  // map update: 
  // --------------
  useEffect(() => {
    // console.log('map trajectory update')
    // only update when necessary: 
    if (( typeof locations !== "undefined" ) && (map) &&
        ( typeof map.getSource(layerId)!== "undefined" ) ) {
      
      // if (props.viewportItemId == 1490) console.log("ViewportItemTrajectory 1490: updating layer.")
      // updating / recreating layer and content
      // updateLayer() inline:

      var points =[] ;
      var segments = [] ;
      var segmentLength ;
      var segmentStartTime = null ;
      for (var i = 0; i < locations.length; i++) {
        if (segmentStartTime===null) {
          segmentStartTime=locations[i].time ;
          segmentLength = 0 ;
        }
  
        // exceptional case: timeout between two points - closing segment
        // (with the current i. point included)
        if ( (i>0) && (locations[i].time - locations[i-1].time ) >
             (lineTimeoutMinutes * 1000 * 60 ) ) {  // TODO: timeout-ot megszoroztam 2000-al
          // close previous segment
          // points, lineWidth, segmentDuration, segmentLength, segmentNr, timeFrom, timeTo
          segments.push( createSegmentFeature( props.viewportItemId, 
                            points, lineWidth, segmentLength, i-1,
                            segmentStartTime, locations[i-1].time) ) ;
          // create 2-point thin segment for above-threshold jumps
          segments.push( createSegmentFeature(  props.viewportItemId, 
            [[locations[i-1].lon, locations[i-1].lat], [locations[i].lon, locations[i].lat]],
            1, locations[i].distPrev, i,
            locations[i-1].time, locations[i].time) ) ;
  
          points =[] ;
          points.push( [locations[i].lon, locations[i].lat] )
          segmentLength = 0 ;
          segmentStartTime =  locations[i].time ;
        }
        // common case: close when segment is long enough
        else {
          points.push( [locations[i].lon, locations[i].lat] ) ;
          segmentLength += locations[i].distPrev ;
          // closing when segment threshold or last point reached:
          if ((segmentLength >= segmentMaxLengthMeter) || (i===locations.length-1) ) {
            segments.push( createSegmentFeature( props.viewportItemId, 
                           points, lineWidth,
                           segmentLength, i,
                           segmentStartTime, locations[i].time) ) ;
            points =[] ;
            points.push( [locations[i].lon, locations[i].lat] )
            segmentLength = 0 ;
            segmentStartTime =  locations[i].time ;
          }
        }
      }
      const source = map.getSource(layerId)
      // console.log("source: ", layerId, '-->', segments)
      var trdata = EMPTY_FEATURES_DATA
      if (source) trdata = source._data
      var newfeats = []
      // drop assigned features (segments): 
      trdata.features.forEach( (feat) => {
        // console.log(segments)
        if (feat.id !== props.viewportItemId) {
          newfeats.push(feat)
        }
        // console.log("adding segment, layer: ", layerId, ", viewportItemId: ", props.viewportItemId)
      })
      // add updated features: 
      if (trajectoryVisible) newfeats = newfeats.concat(segments) // vs. push
      if (trdata.features.length === 0) {
        trdata.features = segments
      }
      else {
        trdata.features = newfeats // trdata.features.concat(segments)
      }
      // if (props.viewportItemId == 1490) console.log("newfeats 1490:", newfeats) // console.log("trdata 1490:", trdata)
            
      //var trdata = map.getLayer(layerId)._data
      //console.log("trdata:", trdata)
      // trdata.features = segments ;
      // trdata.features = trdata.features.concat(segments)

      // var prevFeatures = map.querySourceFeatures(layerId)
      //console.log("trdata: ", layerId, '-->', trdata)
      //trdata.features = segments ;
      source.setData(trdata) // trDATA  TEST_FEATURES_DATA

      // add layer if not present already
      //var beforeLayerName = ( map.getLayer('lastStates') ? 'lastStates' : null ) ;
      //if (! map.getLayer(layerId)) {
      //  map.addLayer({
      //    id: layerId,
      //    type: "line",
      //    source: layerId,
      //    paint: {
      //      'line-color': ['get', 'color'],
      //      'line-width': ['get', 'line-width'],
      //      'line-opacity': 0.7
      //      // TODO: data-driven line-gradient not supported yet
      //    },
      //    layout: {
      //      'line-cap': 'round',  // 'round', 'square', 'butt'
      //      'line-join': 'round', // 'bevel' // 'miter'
      //      //'icon-allow-overlap': true,
      //      // 'text-allow-overlap': true 
      //    },
      //    minzoom: 0,
      //    maxzoom: 24
      //  }, beforeLayerName);
      //  // force update: 
      //  this.map.resize()
      //} 
      
      // force update: 
      //map.resize()

      // TODO: event handlers
      map.on('mouseenter', layerId, function(e) {
        pointerCursor() ;
      });
      // Change it back to a pointer when it leaves.
      map.on('mouseleave', layerId, function() {
        normalCursor() ;  
      });


      map.on('click', layerId, clickHandler)

      //map.on('styledata', function() {
      //  // TODO: do we need forceUpdate? 
      //  //this.forceUpdate()  ;
      //}.bind(this)) 
    }

    // cleanup: 
    return () => {
      if (map) {
        try {
          const source = map.getSource(layerId)
          var trdata = EMPTY_FEATURES_DATA
          if (source) {
            trdata = source._data
            var newfeats = []
            trdata.features.forEach( (feat) => {
              // keep features not assigned to this current viewport item, and drop that one
              if ( feat.id !== props.viewportItemId) {
                // console.log("HIT: ", newfeats, segments, feat)
                newfeats = newfeats.concat(feat)
                // console.log("adding segment, layer: ", layerId, ", viewportItemId: ", props.viewportItemId)
              }
              else {
                //console.log("leaving out: ", feat.id)
              }
            }) 
            source.setData(trdata)
            // remove layer when not displayed
            // if (props.viewportItemId == 1490) console.log("trdata: ", trdata)  
          }   
        }
        catch (e) {
          console.log("ViewportTrajectory: map style not ready, unable to remove layers. ")
        }
        //if (map.getLayer(layerId)) map.removeLayer(layerId)
        //if (map.getSource(layerId)) map.removeSource(layerId)        
  
        map.off('click', layerId, clickHandler);
        //map.off('styledata', this.forceUpdate)
        map.off('mouseenter', layerId, pointerCursor)
        map.off('mouseleave', layerId, normalCursor)  
      }
    }
  }, [map, trajectoryVisible, locations])

  // to force map update:
  
  return  
}